export default __webpack_public_path__ + "static/media/content-section_floating-card.7b425d5c.svg";